// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconShared: React.FC = () => {
    return (
        <svg width="15px" height="13px" viewBox="0 0 15 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="currentColor" fill-rule="evenodd">
                <g id="users" transform="translate(0.000000, 0.500000)" fill-rule="nonzero">
                    <path
                        d="M7.49765611,7.5 C8.84320307,7.5 9.9140625,6.40875006 9.9140625,5.0625 C9.9140625,3.71624994 8.82328105,2.625 7.49765611,2.625 C6.15210915,2.625 5.08124971,3.71624994 5.08124971,5.0625 C5.06015611,6.40781236 6.15234375,7.5 7.49765611,7.5 Z M8.66953111,8.25 L6.33046889,8.25 C4.49062514,8.25 3,9.64921904 3,11.3742185 C3,11.7210939 3.29765618,12 3.66562486,12 L11.3343751,12 C11.7023435,12 12,11.7210939 12,11.3742185 C12,9.64921904 10.5093749,8.25 8.66953111,8.25 Z M12,3.75 C13.0354686,3.75 13.875,2.91046858 13.875,1.875 C13.875,0.839531422 13.0359378,0 12,0 C10.9645314,0 10.125,0.839531422 10.125,1.875 C10.125,2.91046858 10.9640622,3.75 12,3.75 Z M4.31015611,5.0625 C4.31015611,4.93478894 4.33318126,4.81335926 4.34786689,4.68960929 C4.09218764,4.54921889 3.81093764,4.5 3.51328111,4.5 L2.06437504,4.5 C0.924375057,4.5 0,5.47968757 0,6.68671846 C0,6.92812514 0.184851408,7.125 0.412968636,7.125 L5.08874989,7.125 C4.61015618,6.56718779 4.31015611,5.85234368 4.31015611,5.0625 Z M3,3.75 C4.03546858,3.75 4.875,2.91046858 4.875,1.875 C4.875,0.839531422 4.03593743,0 3,0 C1.96453106,0 1.12499964,0.839531422 1.12499964,1.875 C1.12499964,2.91046858 1.96453106,3.75 3,3.75 Z M12.9351568,4.5 L11.4857819,4.5 C11.1857822,4.5 10.9026568,4.57117975 10.6453128,4.69312513 C10.6593747,4.81640625 10.6828122,4.93593764 10.6828122,5.0625 C10.6828122,5.85257792 10.383281,6.56742167 9.90562463,7.125 L14.5860929,7.125 C14.8148432,7.125 15,6.92812514 15,6.68671846 C15,5.47968757 14.0765619,4.5 12.9351568,4.5 Z"
                        id="Shape"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconShared);
